const thresholdDefaultValueList = {
    //globe
    "ndvi_landsat": {
        comparison: "lte",
        range: {
            min: -2,
            max: 2
        },
        default: -0.5,
        description: "Vegetation Index Change (Landsat)",
        unit: 'change in NDVI',
        unitDescription: 'change in NDVI from scale -2 to 2'
    },
    "slope": {
        comparison: "gt",
        range: {
            min: 0,
            max: 360
        },
        default: 90,
        description: "Slope",
        unit: 'lorem ipsum',
        unitDescription: 'lorem ipsum'
    },
    "ndvi_sentinel2": {
        comparison: "lte",
        range: {
            min: -2,
            max: 2
        },
        default: -0.5,
        description: "NDVI change",
        unit: 'change in NDVI',
        unitDescription: 'change in NDVI from scale -2 to 2'
    },
    "VVa": {
        comparison: "lte",
        range: {
            min: -5,
            max: 5
        },
        default: 0.88,
        description: "Backscatter change detected with Sentinel-1 GRD Radar VV polarisation Ascending",
        unit: 'change in backscatter',
        unitDescription: 'change in vertical transmit-vertical receive polarisation',
    },
    "VVd": {
        comparison: "lte",
        range: {
            min: -5,
            max: 5
        },
        default: 0.88,
        description: "Backscatter change detected with Sentinel-1 GRD Radar VV polarisation Descending",
        unit: 'change in backscatter',
        unitDescription: 'change in vertical transmit-vertical receive polarisation'

    },
    "VHa": {
        comparison: "lte",
        range: {
            min: -5,
            max: 5
        },
        default: 0.91,
        description: "Backscatter change detected with Sentinel-1 GRD Radar VH polarisation Ascending",
        unit: 'change in backscatter',
        unitDescription: 'change in vertical transmit-horizontal receive polarisation'
    },
    "VHd": {
        comparison: "lte",
        range: {
            min: -5,
            max: 5
        },
        default: 0.91,
        description: "Backscatter change detected with Sentinel-1 GRD Radar VH polarisation Descending",
        unit: 'change in backscatter',
        unitDescription: 'change in vertical transmit-horizontal receive polarisation'
    },
    "nbi_change": {
        comparison: "lte",
        range: {
            min: -2,
            max: 2
        },
        default: -0.5,
        description: "Normalised Burn Index (Landsat)",
        unit: 'change in NBI',
        unitDescription: 'change in NBI from scale -1 to 1'
    },
    "nbi_sentinel": {
        comparison: "lte",
        range: {
            min: -2,
            max: 2
        },
        default: -0.5,
        description: "Normalised Burn Index (Sentinel)",
        unit: 'change in NBI',
        unitDescription: 'change in NBI from scale -2 to 2'
    },
    "wnd_msk": {
        comparison: "gt",
        range: {
            min: 0,
            max: 50
        },
        default: 3,
        description: "Wind Mask",
        unit: 'm/s',
        unitDescription: 'The instantaneuous wind speed in m/s'
    },
    "water_msk": {
        comparison: "gt",
        range: {
            min: 0,
            max: 100
        },
        default: 25,
        description: "Water Mask",
        unit: '% permanent water cover',
        unitDescription: '% permanent water cover'
    },
    "slope_msk": {
        comparison: "gt",
        range: {
            min: 0,
            max: 60
        },
        default: 5,
        description: "Slope Mask",
        unit: 'degrees',
        unitDescription: 'slope degrees'
    },
    "forest_cov": {
        comparison: "gt",
        range: {
            min: 0,
            max: 100
        },
        default: 25,
        description: "Forest Mask",
        unit: '% vegetation cover',
        unitDescription: 'Percent vegetation cover for forest land cover'
    },
    "forest_cov_10m": {
        comparison: "gt",
        range: {
            min: 10,
            max: 10
        },
        default: 10,
        description: "Forest Mask",
        unit: 'ESA Land Cover Class',
        unitDescription: 'ESA WorldCover 10m v100 Land Cover Class'
    },
    "fr_msk": {
        comparison: "gte",
        range: {
            min: 0,
            max: 100
        },
        default: 60,
        description: "Fires Mask",
        unit: '% of confidence of fire',
        unitDescription: 'FIRMS confidence of fire'
    },
    // environment
    "agr_dr": {
        name: "Agricultural Drought",
        comparison: "lte",
        range: {
            min: 0,
            max: 100
        },
        default: 25,
        description: "The agricultural drought indicator assesses vegetation conditions using NDVI (Normalised Difference Vegetation Index) data. The default threshold is NDVI ≤25th percentile, thereby flagging if data is in the lowest 25% of data for the location historically for the time of year considered.",
        unit: 'Percentile of historical conditions',
        unitDescription: 'Identifies anomalously low NDVI conditions for the location/time of year where the user selected time period is compared to a historical years for same period from 2003 to the selected year.',
        dataSourceUrls: [
            "https://developers.google.com/earth-engine/datasets/catalog/MODIS_006_MOD13A1"
        ],
        dateUpdated: "03-12-2021"
    },
    "met_dr": {
        name: "Meteorological Drought",
        comparison: "lte",
        range: {
            min: -2,
            max: 2        
        },
        default: -1.5,
        description: "The meteorological drought indicator uses rainfall data to calculate the Standardised Precipitation Index (SPI), which measures how rainfall compares to historical conditions for the location. The SPI can be calculated over any timeframe, and the default threshold to flag a location is SPI≤=1.5, which corresponds with very dry conditions.",
        unit: 'SPI Score',
        unitDescription: 'Meteorological drought is calculated as an SPI score lower than -1.5. SPI takes into account long-term historic conditions. SPI<=-1.5 corresponds to Very Dry to Extreme Dry conditions according to the European Drought Observatory or Severe to Extreme Drought according to McKee et al. (1993).',
        dataSourceUrls: [
            "https://chc.ucsb.edu/data/chirps"
        ],
        dateUpdated: "30-11-2021"
    },
    "heatwave": {
        name: "Heatwave",
        comparison: "gte",
        range: {
            min: 0,
            max: 60
        },
        default: 41,
        description: "The heatwave indicator uses daily maximum temperature. The default threshold for a heatwave is 3 consecutive days where maximum temperature is above 41°C, and this flags any location which experiences a heatwave in the time period selected.",
        unit: 'degrees celsius',
        unitDescription: 'Heatwave is defined as three successive of days where max temperature of pixel is above the threshold in °C Selected end date is adjusted to be at least 90 days ago and range is maintained as 16 days (start date is moved accordingly to accomadate this). ',
        dataSourceUrls: [
            "https://cds.climate.copernicus.eu/cdsapp#!/dataset/reanalysis-era5-land?tab=overview"
        ],
        dateUpdated: "30-10-2021"
    },
    "fl_likelihood": {
        name: "Flood Likelihood",
        comparison: "gt",
        range: {
            min: 2,
            max: 1000    
        },
        default: 25,
        description: "The flood likelihood indicator uses modelled flood risk. The default threshold flags locations that would experience flooding (to any depth) under a 25-year return period flood event, based on a baseline scenario for present day. A 25-year return period flood is expected to occur once every 25 years, on average. Options for return periods: 2, 5, 10, 25, 50, 100, 250, 500, 1000",
        unit: 'Flood return period (years)',
        unitDescription: 'Flood likelihood is based on flood risk for different return periods. The default threshold flags locations expected to flood with a 25-year return period flood under baseline conditions represented present day.',
        dataSourceUrls: [
            "http://wri-projects.s3.amazonaws.com/AqueductFloodTool/download/v2/index.html"
        ],
        dateUpdated: "20-10-2020"
    },
    "inund_risk":{
        name: "Coastal Inundation",
        comparison: "lt",
        range: {
            min: 0,
            max: null
        },
        default: 10,
        description: "The coastal inundation indicator is based on a location’s height above sea level. The default threshold flags locations <10m above sea level.",
        unit: 'meters above sea level (fixed)',
        unitDescription: 'Coastal inundation risk is based on height above sea level, with default threshold of 10m as used by Busby et al. (2014).',
        dataSourceUrls: [
            "https://developers.google.com/earth-engine/datasets/catalog/USGS_SRTMGL1_003"
        ],
        dateUpdated: "22-02-2000"
    },
    // conflict
    "conflict_recent_explosions": {
        name: "Conflict (Explosions)",
        comparison: "gt",
        range: {
            min: 1,
            max: null
        },
        default: 1,
        description: "An explosion is a onne-sided violent event where tools used are explosive devices, such as bombs, grenades, air or drone strikes, suicide bombs, etc. Explosions are flagged where there have been a number of event days within 10km square regions over a one year time period. The one year period is one year prior to the selected end date (year end must be at least 90 days ago and will be adjusted if necessary). The default number of event days is one. ",
        unit: 'Event days in past year',
        unitDescription: 'Explosions are flagged where there have been a number of event days within 10km square regions over a one year time period. The one year period is one year prior to the selected end date (year end must be at least 90 days ago and will be adjusted if necessary)',
        dataSourceUrls: [
            "https://acleddata.com/data-export-tool/"
        ],
        dateUpdated: "27-09-2021"
    },
    "conflict_recent_violence": {
        name: "Conflict (Violence)",
        comparison: "gt",
        range: {
            min: 1,
            max: null
        },
        default: 1,
        description: "A violent event is defined as where an organised armed group deliberately inflicts violence upon un-armed civilians. Perpetrators of such acts include state forces and their affiliates, rebels, militias, and external/other forces. Violence is flagged where there have been a number of event days within 10km square regions over a one year time period. The one year period is one year prior to the selected end date (year end must be at least 90 days ago and will be adjusted if necessary). The default number of event days is one. ",
        unit: 'Event days in past year',
        unitDescription: 'Violent events are flagged where there have been a number of event days within 10km square regions over a one year time period. The one year period is one year prior to the selected end date (year end must be at least 90 days ago and will be adjusted if necessary).',
        dataSourceUrls: [
            "https://acleddata.com/data-export-tool/"
        ],
        dateUpdated: "27-09-2021"
    },
    "conflict_recent_protests": {
        name: "Conflict (Protests)",
        comparison: "gt",
        range: {
            min: 1,
            max: null
        },
        default: 1,
        description: "A protest is defined as a public demonstration in which the participants do not engage in violence, though violence may be used against them. Events include individuals and groups who peacefully demonstrate against a political entity, government institution, policy, group, tradition, business, or other private institutions. Protests are flagged where there have been a number of event days within 10km square regions over a one year time period. The one year period is one year prior to the selected end date (year end must be at least 90 days ago and will be adjusted if necessary). The default number of event days is one.",
        unit: 'Event days in past year',
        unitDescription: 'Protests are flagged where there have been a number of event days within 10km square regions over a one year time period. The one year period is one year prior to the selected end date (year end must be at least 90 days ago and will be adjusted if necessary). ',
        dataSourceUrls: [
            "https://acleddata.com/data-export-tool/"
        ],
        dateUpdated: "27-09-2021"
    },
    "conflict_recent_riots": {
        name: "Conflict (Riots)",
        comparison: "gt",
        range: {
            min: 1,
            max: null
        },
        default: 1,
        description: "Riots are defined as violent events where demonstrators or mobs engage in disruptive acts, including but not limited to rock throwing, property descruction, etc. Riots are flagged where there have been a number of event days within 10km square regions over a one year time period. The one year period os one year prior to the selected end date (year end must be at least 90 days ago and will be adjusted if necessary).The default number of event days is one.",
        unit: 'Event days in past year',
        unitDescription: 'Riots are flagged where there have been a number of event days within 10km square regions over a one year time period. The one year period is one year prior to the selected end date (year end must be at least 90 days ago and will be adjusted if necessary). ',
        dataSourceUrls: [
            "https://acleddata.com/data-export-tool/"
        ],
        dateUpdated: "27-09-2021"
    },
    "conflict_battles": {
        name: "Conflict (Battles)",
        comparison: "gt",
        range: {
            min: 1,
            max: null
        },
        default: 1,
        description: "A battle is defined as a violent interaction between at least two politically organised armed groups.Battles can occur between armed and organised state, non-state and external groups, and in any combination therein. Organised armed groups are collective actors assumed to be operating cohesively around an agenda, identity, or political purpose, using weapons to inflict harm. Battles are flagged where there have been a number of event days within 10km square regions over a one year time period. The one year period is one year prior to the selected end date (year end must be at least 90 days ago and will be adjusted if necessary). The default number of event days is one.",
        unit: 'Event days in past year',
        unitDescription: 'Battles are flagged where there have been a number of event days within 10km square regions over a one year time period. The one year period is one year prior to the selected end date (year end must be at least 90 days ago and will be adjusted if necessary).',
        dataSourceUrls: [
            "https://acleddata.com/data-export-tool/"
        ],
        dateUpdated: "27-09-2021"
    },
    // vulnerability
    "pop_density":{
        name: "Population Density",
        comparison: "gt",
        range: {
            min: null,
            max: null
        },
        default: null,
        description: "A Simple way to show higher densely populated areas to overwrap with chosen climate & environmental stresses ",
        unit: 'log of pop density per 100sq. (standard deviation)',
        unitDescription: "Population density is calculated as a LOG of  people per 100 square meters expressed as a  Z-score (number of standard deviations above mean). Threshold is how many 'Z's' above the mean.",
        dataSourceUrls: [
            "https://sedac.ciesin.columbia.edu/data/collection/gpw-v4"
        ],
        dateUpdated: "dd/mm/yyyy"
    },
    "elderly": {
        name: "Elderly population",
        comparison: "gt",
        range: {
            min: -5,
            max: 5
        },
        default: 1,
        description: "The elderly population is calculated as the proportion of the population over 65 years old. This is calculated across the country, and the indicator flags locations where the proportion is a number of standard deviations from the mean for the country. The default threshold is greater than one standard deviation above the mean.",
        unit: 'Standard deviations from the mean',
        unitDescription: 'The elderly population is calculated as the proportion of the population over 65 years old. This is calculated across the country, and the indicator flags locations where the proportion is a number of standard deviations from the mean for the country. The default threshold is greater than one standard deviation above the mean.',
        dataSourceUrls: ["https://explorer.earthengine.google.com/#detail/WorldPop%2FGP%2F100m%2Fpop_age_sex"],
        dateUpdated: "01-01-2021"
    },
    "children": {
        name: "Child population",
        comparison: "gt",
        range: {
            min: -5,
            max: 5
        },
        default: 1,
        description: "The children population is calculated as the proportion of the population under 5 years old. This is calculated across the country, and the indicator flags locations where the proportion is a number of standard deviations from the mean for the country. The default threshold is greater than one standard deviation above the mean.",
        unit: 'Standard deviations from the mean',
        unitDescription: 'The children population is calculated as the proportion of the population under 5 years old. This is calculated across the country, and the indicator flags locations where the proportion is a number of standard deviations from the mean for the country. The default threshold is greater than one standard deviation above the mean.',
        dataSourceUrls: [
            "https://explorer.earthengine.google.com/#detail/WorldPop%2FGP%2F100m%2Fpop_age_sex"
        ],
        dateUpdated: "01-01-2021"
    },
    "female": {
        name: "Female population",
        comparison: "gt",
        range: {
            min: -5,
            max: 5
        },
        default: 1,
        description: "The female population is calculated as the proportion of the population who are female. This is calculated across the country, and the indicator flags locations where the proportion is a number of standard deviations from the mean for the country. The default threshold is greater than one standard deviation above the mean.",
        unit: 'Standard deviations from the mean',
        unitDescription: 'The female population is calculated as the proportion of the population who are female. This is calculated across the country, and the indicator flags locations where the proportion is a number of standard deviations from the mean for the country. The default threshold is greater than one standard deviation above the mean.',
        dataSourceUrls: [
            "https://explorer.earthengine.google.com/#detail/WorldPop%2FGP%2F100m%2Fpop_age_sex"
        ],
        dateUpdated: "01-01-2021"
    },
    "displacement": {
        name: "Displacement",
        comparison: "gt",
        range: {
            min: -5,
            max: 5
        },
        default: 1,
        description: "Displacement uses the number of displaced people per district, with a threshold of the number of standard deviations from the mean number of people across the country. The default threshold is greater than one standard deviation above the mean.",
        unit: 'Standard deviations from the mean',
        unitDescription: 'Displacement uses the number of displaced people per district, with a threshold of the number of standard deviations from the mean number of people across the country. The default threshold is greater than one standard deviation above the mean.',
        dataSourceUrls: ["https://data.humdata.org/dataset/somalia-displacement-idps-returnees-baseline-assessment-iom-dtm"],
        dateUpdated: "July 2022 with data from November 2021"
    },
    "urban_expansion": {
        name: "Urban Expansion",
        comparison: "gte",
        range: {
            min: -5,
            max: 5
        },
        default: 1,
        description: "To identify urban areas likely to be undergoing rapid expansion, this indicator calculates the population change in urban areas from 2015 to the end of the selected period. The threshold identifies (peri-)urban areas where the population change has been a certain number of standard deviations from the mean across urban areas in the country. The default threshold is greater than one standard deviation from the mean",
        unit : "Standard deviations from the mean",
        unitDescription: "",
        dataSourceUrls: [
            "https://developers.google.com/earth-engine/datasets/catalog/WorldPop_GP_100m_pop"
        ],
        dateUpdated: "01-01-2021"
    },
    "access_electricity": {
        name: "Night time light intensity decline",
        comparison: "lt",
        range: {
            min: -1000,
            max: 1000
        },
        default: 0,
        description: "Nighttime light intensity is calculated as the average radiance (nanoWatts/cm2/sr), and decreases in intensity can indicate a decline in access to electricity in some cases. This indicator flags locations where, for any of the months within the selected period, there was a decline in nighttime light intensity, relative to the average for that location over 2014 to the year before the end of the selected period.",
        unit: 'relative % change of radiance from historic data',
        unitDescription: 'Nighttime light intensity is calculated as the average radiance (nanoWatts/cm2/sr), and decreases in intensity can indicate a decline in access to electricity in some cases. This indicator flags locations where, for any of the months within the selected period, there was a decline in nighttime light intensity, relative to the average for that location over 2014 to the year before the end of the selected period.',
        dataSourceUrls: [
            "https://explorer.earthengine.google.com/#detail/NOAA%2FVIIRS%2FDNB%2FMONTHLY_V1%2FVCMSLCFG"
        ],
        dateUpdated: "01-05-2021"
    },
    "access_healthcare": {
        name: "Travel time to healthcare",
        comparison: "gt",
        range: {
            min: -5,
            max: 5
        },
        default: 1,
        description: "The travel time to healthcare indicator uses the time in minutes from each pixel to a hospital or medical clinic (using motorised transport). The threshold is a number of standard deviations from the mean travel time across the country. The default threshold is greater than one standard deviation above the mean travel time.",
        unit: 'Standard deviations from mean ',
        unitDescription: 'The travel time to healthcare indicator uses the time in minutes from each pixel to a hospital or medical clinic (using motorised transport). The threshold is a number of standard deviations from the mean travel time across the country. The default threshold is greater than one standard deviation above the mean travel time.',
        dataSourceUrls: [
            "https://developers.google.com/earth-engine/datasets/catalog/Oxford_MAP_accessibility_to_healthcare_2019"
        ],
        dateUpdated: "2020-01-01"
    },
    "access_healthcare_walking": {
        name: "Travel time to healthcare (by walking)",
        comparison: "gt",
        range: {
            min: 5,
            max: 5
        },
        default: 1,
        description: "The travel time to healthcare indicator uses the time in minutes from each pixel to a hospital or medical clinic (by walking only). The threshold is a number of standard deviations from the mean travel time across the country. The default threshold is greater than one standard deviation above the mean travel time.",
        unit: 'Standard deviations from mean',
        unitDescription: 'The travel time to healthcare indicator uses the time in minutes from each pixel to a hospital or medical clinic (by walking only). The threshold is a number of standard deviations from the mean travel time across the country. The default threshold is greater than one standard deviation above the mean travel time.',
        dataSourceUrls: ["https://developers.google.com/earth-engine/datasets/catalog/Oxford_MAP_accessibility_to_healthcare_2019"],
        dateUpdated: "2020-01-01"
    },
    "food_insecurity": {
        name: "Food Insecurity",
        comparison: "gte",
        range: {
            min: 1,
            max: 5
        },
        default: 3,
        description: "Food insecurity is defined using the IPC Acute Food Insecurity Classification Scale at district level, using FEWS NET's assessments for the time period selected (current assessments rather than projections. The 5 severity phases are: 1 - Minimal/None,  2 -Stressed, 3 - crisis, 4 - Emergency, 5 - Catastrophe/Famine",
        unit: 'IPC crisis scale',
        unitDescription: 'Food insecurity is defined on a IPC Acute Food Insecurity Classification Scale between 1-5 at district level',
        dataSourceUrls: [
            "http://www.ipcinfo.org/ipcinfo-website/ipc-overview-and-classification-system/ipc-acute-food-insecurity-classification/en/#:~:text=In%20particular%2C%20the%20IPC%20Acute,(5)%20Catastrophe%2FFamine."
        ],
        dateUpdated: "July 2022 with data from May 2022"
    },
    "time_to_urban": {
        name: "Travel time to urban areas",
        comparison: "gt",
        range: {
            min: -5,
            max: 5
        },
        default: 1,
        description: "The travel time to urban areas is used as a proxy for accessibility to public services and infrastructure. It is based on the time in minutes from each pixel to the nearest densely-populated area. The threshold is a number of standard deviations from the mean travel time across the country. The default threshold is greater than one standard deviation above the mean travel time.",
        unit: 'Standard deviations from the mean',
        unitDescription: 'The travel time to urban areas is used as a proxy for accessibility to public services and infrastructure. It is based on the time in minutes from each pixel to the nearest densely-populated area. The threshold is a number of standard deviations from the mean travel time across the country. The default threshold is greater than one standard deviation above the mean travel time.',
        dataSourceUrls: ["https://malariaatlas.org/explorer/#/"],
        dateUpdated: "2015"
    },
    "deforestation": {
        name: "Deforestation",
        comparison: "gt",
        range: {
            min: -1000,
            max: 1000
        },
        default: 10,
        description: "Deforestation has a threshold defined for each 10km square region, based on the forest loss in the selected year compared to mean historic forest loss. The default threshold is greater than 10% above the mean loss, with the mean calculated over 2001 to the selected year. Yearly dataset, the year chosen is the one closest to your end date.",
        unit: 'Difference from mean deforestation rate (%)',
        unitDescription: 'Deforestation has a threshold defined for each 10km square region, based on the forest loss in the selected year compared to mean historic forest loss. Yearly dataset, the year chosen is the one closest to your end date.',
        dataSourceUrls: [
            "https://earthenginepartners.appspot.com/science-2013-global-forest"
        ],
        dateUpdated: "01-01-2020"
    },
    "sanitation": {
        name: "Freshwater",
        comparison: "lt",
        range: {
            min: 1,
            max: null
        },
        default: 1,
        description: "This indicator is a proxy for safe drinking water and sanitation facilities. 10 km square grid cells containing <1 freshwater source are flagged.",
        unit: 'freshwater sources',
        unitDescription:'This indicator is a proxy for safe drinking water and sanitation facilities. 10 km square grid cells containing <1 freshwater source are flagged.',
        dataSourceUrls: ["https://spatial.faoswalim.org/layers/geonode:SOM_Strategic_Water_Sources_Feb2018#/"],
        dateUpdated: "Feb 2018"
    },
    "irrigation": {
        name: "Irrigation",
        comparison: "lt",
        range: {
            min: 0,
            max: 100
        },
        default: 10,
        description: "Irrigation has a threshold defined for 10km square regions where the percentage of cropland that is irrigated falls above or below a particular value. The default threshold is less than 10% of cropland in the square is irrigated.",
        unit: '% cropland irrigated',
        unitDescription: 'Irrigation has a threshold defined for 10km square regions where the percentage of cropland that is irrigated falls above or below a particular value. The default threshold is less than 10% of cropland in the square is irrigated.',
        dataSourceUrls: [
            "https://explorer.earthengine.google.com/#detail/USGS%2FGFSAD1000_V1"
        ],
        dateUpdated: "2013"
    },
    "degradation": {
        name: "Land Degradation",
        comparison: "gt",
        range: {
            min: 0,
            max: 100
        },
        default: 10,
        description: "Land degradation has a threshold defined for 10km square regions, where the percentage of degraded land area exceeds a particular value.",
        unit: 'Degraded land area (%)',
        unitDescription: 'Land degradation has a threshold defined for 10km square regions, where the percentage of degraded land area exceeds a particular value.',
        dataSourceUrls: [
            "https://trends.earth/docs/en/index.html#"
        ],
        dateUpdated: "2018"
    },
    "pop_growth":{
        name: "Population Growth",
        comparison: "gt",
        range: {
            min: 0,
            max: null
        },
        default: 3.2,
        description: "Population changes are calculated per 100x100 square, over a period of 5 years up to the selected end date. The default threshold flags locations where population has increased more than 3.2%, which is the natural rate of population increase in Somalia.",
        unit: '% change in population',
        unitDescription: "Population changes are calculated per 100x100 square, over a period of 5 years up to the selected end date. The default threshold flags locations where population has increased more than 3.2%, which is the natural rate of population increase in Somalia.",
        dataSourceUrls: [
            "https://developers.google.com/earth-engine/datasets/catalog/WorldPop_GP_100m_pop"
        ],
        dateUpdated: "01-01-2021"
    },
    "temp":{
        name: "Future Temperature",
        comparison: "gt",
        range: {
            min: 0,
            max: 1
        },
        default: 0.6,
        description: "",
        unit: '°C',
        unitDescription: "",
        dataSourceUrls: [
            ""
        ],
        dateUpdated: ""
    },
    "rainfall":{
        name: "Rainfall",
        comparison: "gt",
        range: {
            min: 0,
            max: 50
        },
        default: 10,
        description: "",
        unit: '%',
        unitDescription: "",
        dataSourceUrls: [
            ""
        ],
        dateUpdated: ""
    },
    "flood":{
        name: "Flooding",
        comparison: "gt",
        range: {
            min: 0,
            max: 5
        },
        default: 3,
        description: "",
        unit: 'models agreeing on flooding',
        unitDescription: "",
        dataSourceUrls: [
            ""
        ],
        dateUpdated: ""
    },
}

export default thresholdDefaultValueList
